var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPickRevert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 77,
    viewBox: "0 0 67 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.7493 72.8786C15.9958 72.8786 3.22511 60.0901 3.22511 44.3147C3.22511 28.5393 15.9958 15.7509 31.7493 15.7509C47.5027 15.7509 60.2734 28.5393 60.2734 44.3147C60.2734 60.0901 47.5027 72.8786 31.7493 72.8786Z",
    fill: "#5DA7EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8223 47.2667C20.5838 67.1836 50.0089 68.1222 54.611 49.1707C59.789 31.0049 38.3373 12.8787 20.51 24.3663C-4.04031 40.1854 11.7499 72.4388 36.1318 71.5337C60.5137 70.6286 66.8388 46.1398 59.345 28.9225C50.1979 7.40055 20.3475 4.03638 3.60322 18.7768C2.79124 14.0849 3.06749 9.26887 4.4106 4.70093L16.8078 18.1182L5.39423 19.2481",
    stroke: "#2C4A43",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickRevert);
export default __webpack_public_path__ + "static/media/pick-revert.de48e64aefe06926f3a371162ed14d72.svg";
export { ForwardRef as ReactComponent };